import { Capacitor } from '@capacitor/core';
import { BarcodeScanner, BarcodeFormat } from '@capacitor-mlkit/barcode-scanning';

// Native barcode scanning via Capacitor ML Kit — a real full-screen
// scanner UI (torch + zoom + close built in), matching the iOS
// AVFoundation experience. On web, Capacitor.isNativePlatform() is false
// and callers fall back to html5-qrcode.
export const isNativeScanner = () => Capacitor.isNativePlatform();

// Opens the native scanner and resolves with the first barcode's raw text.
// Returns null when the user cancels, permission is denied, or scanning
// is unavailable — callers should keep their manual-entry path reachable.
export async function scanOnce() {
  try {
    const perm = await BarcodeScanner.checkPermissions();
    let camera = perm.camera;
    if (camera !== 'granted') {
      const req = await BarcodeScanner.requestPermissions();
      camera = req.camera;
    }
    if (camera !== 'granted') return null;

    const { barcodes } = await BarcodeScanner.scan({
      formats: [BarcodeFormat.QrCode],
    });
    return barcodes?.[0]?.rawValue ?? null;
  } catch {
    return null;
  }
}
